const BASE = process.env.REACT_APP_API_URL ?? "http://localhost:5000/api";

export const downloadTemplate = async (
  hackathonTitle: string,
  problemStatement: string
) => {
  try {
    const params = new URLSearchParams();
    if (hackathonTitle) params.append("hackathonTitle", hackathonTitle);
    if (problemStatement) params.append("problemStatement", problemStatement);

    const response = await fetch(`${BASE}/templates/download?${params}`, {
      method: "GET",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download template");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "idea_submission_template.pptx");
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
    throw error;
  }
};
